export default __webpack_public_path__ + "static/media/Pause.584379df.svg";